<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@import '../../Ad/Ad';
@import '../../AdCallToActions/AdCallToActions';
@import '../../AdPrice/AdPrice';
@import '../../AdVariant/AdVariant';
@import '../../Contact/Contact';
@import '../../ContactGeneralInfo/ContactGeneralInfo';
@import '../../Breadcrumb/Breadcrumb';
@import '../../AccordionPanel/AccordionPanel';
@import '../../AccordionTable/AccordionTable';
@import '../../AccordionContent/AccordionContent';
@import '../../ArticleItem/ArticleItem';
@import '../../ArticleContainer/ArticleContainer';
@import '../../CompanyLogo/CompanyLogo';
@import '../../AboutAdvertiser/AboutAdvertiser';
@import '../../AdHighlightBox/AdHighlightBox';
@import '../../RequirementSearchBanner/RequirementSearchBanner';
@import '../../WidgetEvData/WidgetEvData';
@import '../../MakeModelList/MakeModelList';
</style>
